module.exports = __webpack_public_path__ + "img/settings.7df5611e.svg";